import './Subpage.scss';
import 'Sections/Header/Header';
import 'Sections/Footer/Footer';
import 'Sections/MobileMenu/MobileMenu';
import 'Components/FacebookMessanger/FacebookMessanger';
import CookiePopup from 'Components/CookiePopup/CookiePopup';
class Subpage {
    constructor(node) {
        this.node = node;
    }
    init() {
        console.log('Subpage');
        new CookiePopup();
    }
}
JSModules['Subpage'] = Subpage;
export default Subpage;